export default __webpack_public_path__ + "static/trance03-0481b57b922e7ce78eb52db9e7337e8c.webp";